/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { z, ZodTypes } from './endpoints';

export const CountryCodes = ['at', 'ch', 'de', 'ee', 'pl', 'uy', 'in', 'za'] as const;
export type CountryCode = (typeof CountryCodes)[number];

export type CountryMetadata = {
  callingCode: number;
  phone: { min: number; max: number; mask: string };
  i18n: Record<z.infer<typeof ZodTypes.Language>, string>;
};

export const Countries: Record<CountryCode, CountryMetadata> = {
  at: {
    callingCode: 43,
    phone: { min: 4, max: 13, mask: '9999999999999' },
    i18n: { en: 'Austria', de: 'Österreich' },
  },
  ch: {
    callingCode: 41,
    phone: { min: 9, max: 9, mask: '99 999 99 99' },
    i18n: { en: 'Switzerland', de: 'Schweiz' },
  },
  de: {
    callingCode: 49,
    phone: { min: 5, max: 11, mask: '99999999999' },
    i18n: { en: 'Germany', de: 'Deutschland' },
  },
  ee: {
    callingCode: 372,
    phone: { min: 7, max: 8, mask: '9999 9999' },
    i18n: { en: 'Estonia', de: 'Estland' },
  },
  pl: {
    callingCode: 48,
    phone: { min: 9, max: 9, mask: '999-999-999' },
    i18n: { en: 'Poland', de: 'Polen' },
  },
  uy: {
    callingCode: 598,
    phone: { min: 8, max: 8, mask: '9999-9999' },
    i18n: { en: 'Uruguay', de: 'Uruguay' },
  },
  in: {
    callingCode: 91,
    phone: { min: 10, max: 10, mask: '99999-99999' },
    i18n: { en: 'India', de: 'Indien' },
  },
  za: {
    callingCode: 27,
    phone: { min: 9, max: 9, mask: '99 999 9999' },
    i18n: { en: 'South Africa', de: 'Südafrika' },
  },
};
